// extracted by css-extract-rspack-plugin
export default {"dependency":"dependency-Ix8fWZ","predecessor__select":"predecessor__select-cY_jkY","predecessorSelect":"predecessor__select-cY_jkY"};